var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales-order-number",on:{"click":_vm.showOverlay}},[_vm._v(_vm._s(_vm.sono))])}
var staticRenderFns = []

export { render, staticRenderFns }